import React from "react";

export default function XpertAssistHero() {
  return (
    <section className="py-5">
      <div className="whatweoffercontainer">
        <div className="v-row row align-items-center justify-content-center items-center justify-center v-row align-center justify-center">
          
          <div className="col-12 col-md-10 col-lg-10 col-xl-6 pr-7 my-6 v-col-12 v-col-md-10 v-col-lg-10 v-col-xl-6">
            <img
              src="/assets/images/whatweoffer/whatweofferlogo.png"
              alt="logo"
              width="184"
              height="43"
              className="mb-3"
            />
            <h1 className="display-4 lh-sm mb-4 mt-4" style={{fontWeight:"800"}}>
Choosing the right financial <br/> firm is key to success!
            </h1>
            <p className="fs-4 text-dark col-12 col-lg-10 px-0 mb-4">
              We believe choosing the right financial partner is the foundation
              of lasting success. Our team combines expertise, strategy, and
              personalized support to help you achieve your financial goals with
              confidence and clarity.
            </p>

            <a
              href="/tax"
              className="text-purple text-decoration-none"
            >
              See How We Help You
            </a>
          </div>

          {/* RIGHT SIDE CARD */}
          <div className="v-col-12 mx-auto col-md ml-lg-5 mb-8 mb-md-0 v-col-md ms-5 p-3">
            <div className="box-test rounded-4">
              <div
                className="box-test-child border-top-right rounded-4"
                style={{ padding: "4rem" }}
              >
                {/* card header */}
                <img
                  src="/assets/images/whatweoffer/whatweofferlogo.png"
                  alt="logo"
                  width="135"
                  height="23"
                />
                <h2 className="what-we-offer-text display-6 pt-5 mt-1 pb-4 m-0 fw-bold">
                  What We Offer
                </h2>
                <p className="text-dark mb-4 col-12 col-lg-11 px-0">
                 Experienced tax consultants offering complete services to secure your financial future and resolve tax issues quickly and efficiently.
                </p>

                {/* features */}
                <div className="row gy-2">
                  <div className="col-12 col-xl-6">
                    <p
                      style={{ fontSize: "15px" }}
                      className="mb-2 d-flex fw-bold text-dark align-items-center"
                    >
                      <i
                        className="fa fa-check pe-2"
                        color="#3D2B11"
                        aria-hidden="true"
                      ></i>
                      Unlimited sessions
                    </p>
                    <p
                      style={{ fontSize: "15px" }}
                      className="mb-2 d-flex text-dark align-items-center"
                    >
                      <i
                        className="fa fa-check pe-2"
                        color="#3D2B11"
                        aria-hidden="true"
                      ></i>
                      Credentialed tax experts
                    </p>
                    <p
                      style={{ fontSize: "15px" }}
                      className="mb-2 d-flex text-dark align-items-center"
                    >
                      <i
                        className="fa fa-check pe-2"
                        color="#3D2B11"
                        aria-hidden="true"
                      ></i>
                      All consumer forms
                    </p>
                  </div>

                  <div className="col-12 col-xl-6">
                    <p
                      style={{ fontSize: "15px" }}
                      className="mb-2 d-flex text-dark align-items-center"
                    >
                      <i
                        className="fa fa-check pe-2"
                        color="#3D2B11"
                        aria-hidden="true"
                      ></i>
                      100% U.S.-based tax experts
                    </p>
                  </div>
                </div>

                {/* CTA in gradient frame bottom-left radius */}
                <div className="border-bottom-left pt-5">
                  <a
                    href="/contact-us"
                    className="btn btn-primary w-100 rounded-pill py-3 tmp-btn btn-primary button-custom whatweoffer-btn"
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* /RIGHT */}
        </div>
      </div>

      <style >{`
        :root {
          --ta-primary-btn-bg: #6651e1;
          --ta-primary-btn-border: #6651e1;
          --ta-primary-btn-hover: #4c3da8;
          --ta-primary-btn-focus: #bdb4f2;
          --ta-primary-btn-active: #33187e;
          --ta-primary-btn-disabled: #d3cdf6;
          --ta-link-color: #6651e1;
          --ta-body-color: #171138;
        }

        .whatweoffercontainer {
          margin-left: auto;
          margin-right: auto;
          padding: 16px;
          max-width: 1140px;
        }

        @media (max-width: 1400px) {
          .whatweoffercontainer {
            max-width: 1140px;
          }
        }
        @media (max-width: 1200px) {
          .whatweoffercontainer {
            max-width: 1140px;
          }
        }
        @media (max-width: 992px) {
          .whatweoffercontainer {
            max-width: 960px;
          }
        }
        @media (max-width: 768px) {
          .whatweoffercontainer {
            max-width: 720px;
          }
        }
        @media (max-width: 576px) {
          .whatweoffercontainer {
            max-width: 540px;
          }
        }

        .xpert-assist-section {
          background: #fff;
          color: var(--ta-body-color);
          font-family: "Barlow", "Helvetica Neue", Arial, sans-serif;
        }

        .what-we-offer-text{
        font-size: 2rem;
    font-weight: 700;
    text-transform: capitalize;
    background: linear-gradient(270deg, black, #00A1E4);
    background-size: 400% 400%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    animation: gradientMove 8s 
ease infinite;
}



        .text-purple {
          color: #2aabe0;
          font-weight: 600;
          font-size: 16px;
          position: relative;
          text-decoration: none;
        }
        .text-purple:hover {
          text-decoration: underline;
        }
        .text-purple::after {
          content: "";
          background: url("assets/images/whatweoffer/right-arrow.svg")
            no-repeat 100%;
          height: 24px;
          width: 20px;
          display: inline-block;
          margin-left: 6px;
          vertical-align: middle;
        }

        .box-test {
          position: relative;
          padding: 3px;
          border-radius: 0 20px;
          z-index: 1;
        }
        .box-test::before,
        .box-test::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 0 20px;
          background: linear-gradient(45deg, #2aabe0, #003B78 35%, #2aabe0);
          display: flex;
        }
        .box-test::before {
          transform: translate(10px, 10px);
          z-index: -2;
        }
        .box-test::after {
          z-index: -1;
        }
        .box-test-child {
          background: #fff;
          width: 100%;
          border-radius: 0 20px;
          position: relative;
          z-index: 2;
        }

        .border-top-right {
          border-radius: 0px 20px 0px 20px;
        }
        .border-bottom-left {
          border-radius: 0 0 0 20px;
        }

        .whatweoffer-btn {
          font-size: 20px !important;
    height: 50px;
    display: flex !important
;
    justify-content: center;
    align-items: center;
        }

        .whatweoffer-btn::after {
          border-radius: 78px !important;
        }

        @media (max-width: 991.98px) {
          .display-4 {
            font-size: 2.2rem;
            line-height: 1.2;
          }
          .box-test::before {
            transform: translate(6px, 6px);
          }
        }

        @media (max-width: 575.98px) {
          .text-purple::after {
            height: 20px;
            width: 16px;
          }
        }
      `}</style>
    </section>
  );
}
